import React, { Component} from 'react';
import { translate } from 'react-i18next';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import moment from 'moment';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import ModalPersonSearch from '../../generics/modal_person_search';
import swal from 'sweetalert';
import ModalCenter from '../../generics/modalCenter';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';

var Config = require('../../../config');

class PatientData extends Component{

	constructor(props, context) {
		super(props, context);
		this.updateState = this.updateState.bind(this);
		this.availableEdit = this.availableEdit.bind(this);
		this.getNationalCenters = this.getNationalCenters.bind(this);
		this.person_search = this.person_search.bind(this);
		this.addCenter = this.addCenter.bind(this);

		this.state = { 
	    	health_facilities:[],
	    	facility_sections:[],
	    	relationships:[],
	    	rhGroup:[],
	    	dataSource:[],
	    	searchText: '',
	    	national_centers:[],
	    	rh_group:"",
	    	isLoading: false,
	    	observations:false,
	    	disablePatient: false,

	    	requestedSelected:[],
	    	indice:-1,
	    	emergency_levels:[],
			options:[],
			user_add_center:"",
			pac_usr_npm:{}
	    }
	}

	//Consulta de servicios necesarios para la pantalla
	componentDidMount() {
		this.props.onRef(this);

		if(this.props.state.blockFieldsPatient){
			this.setState({disablePatient:true});
		}

		

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=USER_ADD_CENTER&x=', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					user_add_center: response.value
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAC_USR_NPM&x=', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					pac_usr_npm: response.value
				});

				if(response.value === 'NO'){	
					
					if(this.props.location.pathname.indexOf('new') !== -1){
						this.props.getNextPatient();
					}				
					
				}
			}
		});

		//parentesco
		fetch(Config.default.apiGateway.URL+'lookups?type=FAMILIAR_RELATIONSHIP&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      relationships: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=PATIENT_EMERGENCY_LEVEL&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      emergency_levels: response
		    });
		})

		//grupos sanguineos
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      rhGroup: response
		    });
		})

		this.getNationalCenters();
	}

	getNationalCenters(){
		//national centers
		fetch(Config.default.apiGateway.URL+'national_centers?option=origin_patients&health_facility='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      national_centers: response
		    });

			if(this.props.state.national_center_id !== ""){
				this.setNationalCenter(this.props.state.national_center_id);
			}
		})
	}

	componentWillUnmount() {
	    this.props.onRef(null)
	}

	//seleccion de grupo y rh
	rhGroupHandleChange = (event) => {
		for(var i=0; i < this.state.rhGroup.length;i++){
			if(this.state.rhGroup[i].name === event.target.value){
				this.props.autocompleteHandle('lookup_group',this.state.rhGroup[i].key_group);
				this.props.autocompleteHandle('lookup_rh',this.state.rhGroup[i].key_rh);
			}
		}
		this.props.selectFieldHandle("id","lookup_value",event);
	}

	nationalCenterSelected = (id, name, event, index, value) => {
		this.props.selectFieldHandle("id","national_center_id",event, index, value);
	}

	//Evento para checkbox
	handleCheck = event => {
	    this.setState({
	      [event.target.name]: event.target.checked
	    });
	}

	//busqueda paciente
	_handleSearch = (query) => {
	    this.setState({isLoading: true});

		fetch(Config.default.apiGateway.URL+'person?search='+query,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
				}),
				cache:"no-cache"
			})
			.then(response => response.json())
			.then(response => {
				for (var i = 0; i < response.length; i++) {
						
						/* revisar en la base de datos el lastname1 y lastname2 ya que lastname1 contiene el lastname2*/

						if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
							response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '
												+response[i].names +' '+ 
												(response[i].birthday !== null ? response[i].birthday : '');
						
						}else{
							response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
												(response[i].birthday !== null ? response[i].birthday : '');
						}


						if(response[i].document_type_value !== null){
							response[i].names +=' '+response[i].document_type_value;
						}

						if(response[i].document_number !== null){
							response[i].names +=' '+response[i].document_number;
						}

						if(response[i].number !== null){
							response[i].names += ' '+response[i].number
						}
						response[i].id = response[i].person_id;
					};
				this.setState({
					isLoading: false,
			     	options: response
			    });


			    setTimeout(()=>{
			    	if(this.modal_person_search.state.show){
			    		var id = '';
			    		this.modal_person_search.state.list.map((p)=>{
			    			if(p.check){
			    				id = p.person_id;
			    			}
			    		});

			    		var index = this.state.options.findIndex(obj => 
			    			 parseInt(obj.person.id) === parseInt(id)
			    		);

			    		if(index !== -1){
			    			this.updateState([this.state.options[index]]);
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}else{
			    			swal('Información', 'El paciente seleccionado ya se encuentra en el listado', 'info')
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}
			    	}
			    	
			    }, 500);
			})
	}

	updateState(values) {
	    let value = '';
	    if (values.length > 0) {
			value = values[0];
			  
			this.props.autocompleteHandle('blockFieldsPatient',true);
			this.props.autocompleteHandle('checkEditDataPatient',true);
			fetch(Config.default.apiGateway.URL+'patients/patient_offer?id='+value.patient_id,{
				method:'GET',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(this.props.waiting !== undefined){
					this.props.waiting.handleClose();	
				}
				
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					this.props.setInfoPatient(response)			 			
				}
			})
	    }
		
		


	    
	}

	clear(e){
		e.preventDefault();
		this.refs._handleSearch_nc._instance.clear();
		this.props.clearPatientSearch();

	}

	availableEdit(e){
		if(!e.target.checked){
			this.setState({
				disablePatient: true
			});
		}else{
			this.setState({
				disablePatient: false
			})
		}
		this.props.autocompleteHandle('blockFieldsPatient',!e.target.checked);
	}

	/*autocomplete national center*/

	_handleSearchNC = (query) => {
		
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	this.setState({
				indice:0,
				requestedSelected:values,
		    });
        	this.props.autocompleteHandle(name,values[0].id);

        }else if(this.state.requestedSelected.length > 0){
        	this.setState({
				requestedSelected:[]
		    });
        }
	}
	
	clearSearch(){
		this.refs._handleSearch_nc._instance.instanceRef.clear();
		this.setState({requestedSelected:[]});
	}

    setNationalCenter(center){
    	for (var i = 0; i < this.state.national_centers.length; i++) {
			if (this.state.national_centers[i].id === center) {
				this.setState({
					indice:i,
					requestedSelected: [this.state.national_centers[i]],
				});
				break;
			}
		}	
    }

    person_search(){
		this.modal_person_search.handleShow(
			'Paciente',
			'patients'
		);
	}

	addCenter(){
		this.modal_add_center.handleShow();
	}

	render(){
		const { t } = this.props;
		return(
			<fieldset className="col-xs-12 form-group" style={{padding:'0px'}}>
				<legend>Datos del Paciente</legend>
				<div className="col-xs-12" style={{padding:"0px"}}>
					<div className="col-xs-7">
						<span className="span-min">{t('content.generics.buttons.search')}</span>
				        <AsyncTypeahead
				         /*{...this.state}*/
				          labelKey={(option) => `${option.names}`}
				          minLength={3}
				          name="patient"
				          id="patient"
				          disabled={this.state.disablePatient}
				          onSearch={this._handleSearch}
				          placeholder="Buscar por apellidos más nombre o número de documento..."
				          options={this.state.options}
				          onChange={this.updateState}
				          ref="_handleSearch"
				          useCache={false}
				          isLoading={this.state.isLoading}
				          paginationText="Mostrar mas resultados..."
				        />
					</div>
					<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
						<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
							onClick={this.person_search}/>
					</div>
					<div className="col-xs-12 col-sm-2">
						<button style={{marginTop:"16px",marginLeft:"5px"}} type="button" 
							className="btn btn-info button-min" onClick={(e)=>this.clear(e)}
							disabled={this.state.disablePatient}>
							LIMPIAR
						</button>
					</div>
				</div>
				{this.props.state.checkEditDataPatient?
				<div className="col-xs-12">
					<input className="form-check-input" type="checkbox" name="blockFields" 
						onKeyPress={(e) => this.props.validate(e)}
		        		value={ this.props.state.blockFieldsPatient} 
		        		onChange={ this.availableEdit } style={{marginRight:'5px'}}/>
		        	<span className="span-min">Editar Datos</span>
			    </div>
			    :null}
				<div className="col-xs-12 col-md-4" >
					<span className="span-min">{t('content.offers.form.names')}</span>
					<input className="form-control input_data_donor" name="patient_name" id="patient_name" 
						disabled={this.state.disablePatient} onKeyPress={(e) => this.props.validate(e)}
 						value={ this.props.state.patient_name } onChange={ this.props.handleChange }
					/>
				</div>
				<div className="col-xs-12 col-md-2" >
					<span className="span-min">{t('content.offers.form.lastname1')}</span>
					<input className="form-control input_data_donor" name="patient_lastname1" id="patient_lastname1"
						disabled={this.state.disablePatient}
		 				value={ this.props.state.patient_lastname1 } onKeyPress={(e) => this.props.validate(e)}
		 				onChange={ this.props.handleChange }/>
				</div>
				<div className="col-xs-12 col-md-2" >
					<span className="span-min">{t('content.offers.form.lastname2')}</span>
					<input className="form-control input_data_donor" name="patient_lastname2" id="patient_lastname2"
						onKeyPress={(e) => this.props.validate(e)}
						disabled={this.state.disablePatient}
		 				value={ this.props.state.patient_lastname2 } onChange={ this.props.handleChange } 
					/>
				</div>
				<div className="col-xs-12 col-sm-2" >
					<span className="span-min">{t('content.offers.form.gender')}</span>
		            <select className="form-control" id="patient_sex" name="patient_sex" 
		            	onKeyPress={(e) => this.props.validate(e)} disabled={this.state.disablePatient}
		            	value={this.props.state.patient_sex} onChange={this.props.handleChange} > 
				        <option value="" >Seleccionar...</option>
		                <option value="HOMBRE" >HOMBRE</option>
		                <option value="MUJER" >MUJER</option>
	              	</select>
				</div>
				
				<div className="col-xs-12 col-md-2" >
					<span className="span-min">{t('content.offers.form.birthday')}</span>
					<MaskedFormControl type='text' name="patient_birthday" id="patient_birthday" 
						value={this.props.state.patient_birthday} disabled={this.state.disablePatient}
						onChange={this.props.dateHandleChange} onKeyPress={(e) => this.props.validate(e)}
						mask='11/11/1111' placeholder="dd/mm/yyyy" className="form-control input-date" />
		        </div>
				<div className="col-xs-12" style={{padding:'0px'}}>
					{	
					this.state.hemored?
					<div style={{padding: "0px"}}>
						<div className="col-xs-12 col-sm-4" >
							<span className="span-min">{t('content.offers.form.health_facility')}</span>
				            <select className="form-control" onKeyPress={(e) => this.props.validate(e)}
				            	disabled={this.state.disablePatient} 
				            	id="health_facility_id"
								onChange={ this.healthFacilitySelected.bind(null,"id","health_facility_id") } 
				             	name="health_facility_id" value={ this.props.state.health_facility_id }>
						        <option value="" disabled>Seleccionar...</option> 
				                {
					                this.state.health_facilities.map(function(t) {

					                  return <option key={t.id}  value={t.id} >{t.name} </option>;
					                })
					            }
			                
			              	</select>
				        </div>
				        <div className="col-xs-12 col-sm-4">
				        	<span className="span-min">{t('content.offers.form.service')}</span>
				            <select className="form-control input_data_donor" name="facility_section_id" 
				            	id="facility_section_id" 
				            	disabled={this.state.disablePatient} 
						        value={ this.props.state.facility_section_id } onKeyPress={(e) => this.props.validate(e)}
						        onChange={ this.props.selectFieldHandle.bind(null,"id","facility_section_id") }
						        > 
						        <option value="" disabled>Seleccionar...</option>
				                {
					                this.state.facility_sections.map(function(t) {
					                  return <option key={t.id}  value={t.id} >{t.name} </option>;
					                })
					            }
			              	</select>
				        </div>
					</div>
					:<div style={{padding:"0px"}}>
						<div className="col-xs-12 col-sm-4">
							<div>
								<span className="span-min">{t('content.offers.form.health_facility')}</span>
							</div>
							<div style={{width:this.state.user_add_center === 'YES' ? '90%' : '100%', display:'inline-block'}}>
								<AsyncTypeahead 
									/*{...this.state}*/
									labelKey={(option) => `${option.name}`}
									minLength={0}
									disabled={this.state.disablePatient} 
									onKeyPress={(e) => this.props.validate(e)}
									options={this.state.national_centers}
									onChange={this.handleTypeAheadChange('national_center_id')}
									onSearch={this._handleSearchNC}
									inputProps={{
										name:"national_center_id",
										id:"national_center_id"
									}}
									id="nationalCenterId"
									defaultSelected={this.state.national_centers.slice(this.state.indice, 1)}
										selected={this.state.requestedSelected}
									ref="_handleSearch_nc"
									className="input_data_donor"
									useCache={false}
									isLoading={this.state.isLoading}
									delay={600}
								/>
							</div>
							{this.state.user_add_center === 'YES' &&
								<div style={{width:'10%', display:'inline-block', textAlign:'center'}}>
									<FloatingActionButton className="action-btn" iconStyle={{height: 20, width: 20}} mini={true} 
										onClick={this.addCenter}  >
										<ContentAdd/>
									</FloatingActionButton> 
								</div>
							}
				        </div>
				        <div className="col-xs-12 col-sm-4">
				        	<span className="span-min">{t('content.offers.form.service')}</span>
				        	<input className="form-control" name="national_name" id="national_name" onKeyPress={(e) => this.props.validate(e)}
					 			value={ this.props.state.national_name } 
					 			disabled={this.state.disablePatient} 
					 			onChange={ this.props.handleChange }/>
				        </div>
					</div>
					}
						
			        <div className="col-xs-12 col-sm-2">
			        	<span className="span-min">{t('content.offers.form.relationship')}</span>
			            <select className="form-control input_data_donor" name="relationship" id="relationship" 
			            	value={ this.props.state.relationship } 
			            	disabled={this.state.disablePatient} 
					        onChange={ this.props.selectFieldHandle.bind(null,"id","relationship") } onKeyPress={(e) => this.props.validate(e)}> 
					        <option value="" disabled>Seleccionar...</option>
			                {
				                this.state.relationships.map(function(t) {
				                  return <option key={t.id}  value={t.key} >{t.name} </option>;
				                })
				            }
		                
		              	</select>
			        </div>
					<div className="col-xs-12 col-sm-2">
			        	<span className="span-min">No. IMSS</span>
			            <input className="form-control input_data_donor" name="social_number" id="social_number" onKeyPress={(e) => this.props.validate(e)}
					 			value={ this.props.state.social_number || "" } 
					 			disabled={this.state.disablePatient} 
					 			onChange={ this.props.handleChange }/>
			        </div>
			        <div className="col-xs-12 col-md-2" >
			        	<span className="span-min">{t('content.offers.form.no_file')}</span>
			        	<input className="form-control input_data_donor" name="no_file" id="no_file" value={ this.props.state.no_file || "" } 
			        		disabled={this.state.disablePatient} onChange={ this.props.handleChange } 
			        		onKeyPress={(e) => this.props.validate(e)}/>
		 			</div>
					<div className="col-xs-12 col-md-2" >
						<span className="span-min">{t('content.offers.form.rh_group')}</span>
						
						<select className="form-control input_data_donor" name="rh_group" id="rh_group" 
								disabled={this.state.disablePatient ? true :
									this.state.rh_group === null ? false :
										this.state.rh_group === "" ? false : true
								}
								value={ this.props.state.rh_group ||""} onKeyPress={(e) => this.props.validate(e)}
								onChange={ this.rhGroupHandleChange.bind(this) } > 
							<option value="">Seleccionar...</option>
							{
								this.state.rhGroup.map(function(t,index) {
								return <option key={index}  value={t.name} >{t.name} </option>;
								})
							}
						</select>
					</div>
					<div className="col-xs-12 col-md-2" >
			        	<span className="span-min">Nivel de urgencia paciente</span>
			        	<select className="form-control" name="emergency_level" id="emergency_level" 
			        		value={this.props.state.emergency_level || ""} onChange={this.props.handleChange}>
			        		<option value="">Seleccione...</option>
			        		{this.state.emergency_levels.map((e, i)=>(
			        			<option key={i} value={e.key}>{e.name}</option>
			        		))}
			        	</select>
		 			</div>
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Número de Paciente</span>
						<input className="form-control hour-input" 
							name="patient_number" id="patient_number"
							disabled={this.state.pac_usr_npm === 'NO'}
							value={this.props.state.patient_number} onChange={(e)=>this.props.handleChange(e)} />
					</div>
				</div>	
				<div className="col-xs-12">
					<input className="form-check-input" type="checkbox" name="observations"  
						onKeyPress={(e) => this.props.validate(e)}
			        	value={ this.state.observations} onChange={ this.handleCheck } 
			        	disabled={this.state.disablePatient}  
			        	style={{marginRight:'5px'}}/>
		        	<span className="span-min">{t('content.offers.form.comments')}</span>
		        	
			    </div>
			    {this.state.observations?
				<div className="col-xs-12 col-sm-8" >
		        	<input className="form-control" name="observations" id="observations"
		        		onKeyPress={(e) => this.props.validate(e)}
		        		value={ this.props.state.observations } 
		        		disabled={this.state.disablePatient} 
		        		onChange={ this.props.handleChange } />
				</div>
				:null}

				<ModalPersonSearch {...this.props} 
					waiting={this.props.waiting} 
					updatePerson={this.updateState} 
					onRef={ref => (this.modal_person_search = ref)} 
					search={this.updateState}
					persons={this.state.options}
				/>
				
				<ModalCenter {...this.props} onRef={ref => (this.modal_add_center = ref)} 
					refresh={this.getNationalCenters} />
		    </fieldset>
		)
	}
}

export default translate('translations')(PatientData);